// extracted by mini-css-extract-plugin
module.exports = {"clickable_panel":"ClickablePanel_clickable_panel__1DHQM","no_padding":"ClickablePanel_no_padding__M2Uv4"};